<div class="card border-0 bg-transparent">
  <div class="card-header">
    <h5 class="card-title">Employee Personal Account Dealing Declaration</h5>
    <p class="card-text text-muted">HONG KONG</p>
  </div>
  <div class="card-body">
    <p>
      To: Legal and Compliance Department<br />
      Compagnie d'Investissements et de Gestion Priv&eacute;e (Hong Kong) Limited (&ldquo;CIGP HK&rdquo;)
    </p>
    <p>Re: Employee Personal Account Dealing Declaration</p>
    @if (hasLastYearData && !alreadySubmitted) {
      <ad-alert-data-preloaded></ad-alert-data-preloaded>
    }
    <form [formGroup]="form">
      <p>Please note that I, {{ name$ | async }}, would like to notify CIGP HK on the following:</p>

      <!-- Personal dealing accounts -->
      <div class="mb-3">
        <ejs-switch formControlName="hasPersonalDealingAccounts"></ejs-switch>
        <label class="ms-2">{{ hasPersonalDealingAccountsLabel }}</label>
      </div>
      @if (hasPersonalDealingAccounts) {
        <ng-container formArrayName="personalDealingAccounts">
          @for (dealingAccount of personalDealingAccounts.controls; track dealingAccount; let i = $index) {
            <div class="d-flex align-items-center mt-2" [formGroup]="getAsFormGroup(dealingAccount)">
              <div class="card">
                <div class="card-header">
                  <div class="card-subtitle">Dealing Account {{ i + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <label class="form-label">Name of broker / investment plan</label>
                    <ejs-textbox formControlName="brokerName"></ejs-textbox>
                    @if (dealingAccount.get('brokerName')?.hasError('required')) {
                      <small class="text-danger d-block">Name of broker / investment plan is required</small>
                    }
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Account number</label>
                    <ejs-textbox placeholder="Account number" formControlName="accountNumber"></ejs-textbox>
                    @if (dealingAccount.get('accountNumber')?.hasError('required')) {
                      <small class="text-danger d-block">Account number is required</small>
                    }
                  </div>
                </div>
              </div>
              <div>
                <button
                  class="btn btn-sm btn-outline-danger ms-2"
                  (click)="removePersonalDealingAccount(i)"
                  [disabled]="alreadySubmitted"
                >
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
            </div>
          }
          <div class="mt-2">
            <button
              class="btn btn-sm btn-outline-primary"
              (click)="addPersonalDealingAccount()"
              title="Add dealing account"
              [disabled]="alreadySubmitted"
            >
              <i class="bi bi-plus-circle"></i> Add dealing account
            </button>
          </div>
        </ng-container>
      }

      <!-- Related persons -->
      <div class="mb-3 mt-3">
        <ejs-switch formControlName="hasRelatedPersons"></ejs-switch>
        <label class="ms-2">{{ hasRelatedPersonsLabel }}<sup>1</sup></label>
      </div>
      @if (hasRelatedPersons) {
        <ng-container formArrayName="relatedPersons">
          @for (relatedPerson of relatedPersons.controls; track relatedPerson; let i = $index) {
            <div class="d-flex align-items-center" [formGroup]="getAsFormGroup(relatedPerson)">
              <div class="card flex-grow-1">
                <div class="card-header">
                  <div class="card-subtitle">Related Person {{ i + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <label class="form-label">Name</label>
                    <ejs-textbox formControlName="name"></ejs-textbox>
                    @if (relatedPerson.get('name')?.hasError('required')) {
                      <small class="text-danger d-block">Name is required</small>
                    }
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Address</label>
                    <ejs-textbox
                      placeholder="Address"
                      multiline="true"
                      rows="3"
                      formControlName="address"
                    ></ejs-textbox>
                    @if (relatedPerson.get('address')?.hasError('required')) {
                      <small class="text-danger d-block">Address is required</small>
                    }
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Relationship</label>
                    <ejs-textbox placeholder="Relationship" formControlName="relationship"></ejs-textbox>
                    @if (relatedPerson.get('relationship')?.hasError('required')) {
                      <small class="text-danger d-block">Relationship is required</small>
                    }
                  </div>
                  <ng-container formArrayName="dealingAccounts">
                    @for (
                      dealingAccount of getRelatedPersonDealingAccounts(i).controls;
                      track dealingAccount;
                      let i1 = $index
                    ) {
                      <div class="d-flex align-items-center mb-2" [formGroup]="getAsFormGroup(dealingAccount)">
                        <div class="card flex-grow-1">
                          <div class="card-header">
                            <div class="card-subtitle">Dealing Account {{ i1 + 1 }}</div>
                          </div>
                          <div class="card-body">
                            <div class="mb-3">
                              <label class="form-label">Name of broker / investment plan</label>
                              <ejs-textbox formControlName="brokerName"></ejs-textbox>
                              @if (dealingAccount.get('brokerName')?.hasError('required')) {
                                <small class="text-danger d-block">Name of broker / investment plan is required</small>
                              }
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Account number</label>
                              <ejs-textbox placeholder="Account number" formControlName="accountNumber"></ejs-textbox>
                              @if (dealingAccount.get('accountNumber')?.hasError('required')) {
                                <small class="text-danger d-block">Account number is required</small>
                              }
                            </div>
                          </div>
                        </div>
                        @if (getRelatedPersonDealingAccounts(i).length > 1) {
                          <button
                            class="btn btn-sm btn-outline-danger ms-2"
                            (click)="removeRelatedPersonDealingAccount(i, i1)"
                          >
                            <i class="bi bi-x-circle"></i>
                          </button>
                        }
                      </div>
                    }
                    <button
                      class="btn btn-sm btn-primary mt-2"
                      (click)="addRelatedPersonDealingAccount(i)"
                      [disabled]="alreadySubmitted"
                      title="Add dealing account"
                    >
                      <span class="material-icons">add</span>
                    </button>
                  </ng-container>
                </div>
              </div>
              <button
                class="btn btn-sm btn-outline-danger ms-2"
                (click)="removeRelatedPerson(i)"
                [disabled]="alreadySubmitted"
              >
                <i class="bi bi-x-circle"></i>
              </button>
            </div>
          }
          <div class="my-3">
            <button
              class="btn btn-sm btn-outline-primary"
              (click)="addRelatedPerson()"
              title="Add related person"
              [disabled]="alreadySubmitted"
            >
              <i class="bi bi-plus-circle"></i> Add related person
            </button>
          </div>
        </ng-container>
      }
      <p>
        <small>
          Related Person can be defined as (i) member(s) of an Employee's immediate family (including spouse or civil
          partner, any minor child (natural or adopted) or minor step-child) or persons living in the same household for
          at least one year on the date of the transaction or otherwise closely connected, (ii) legal or other entities
          connected to an Employee (e.g. companies, trusts and estates with which he/she is related or with which he/she
          has a shared interest), (iii) other natural persons whose services are placed at the disposal and under the
          control of CIGP HK and an outsource provider whose purpose is the provision of regulated activities and other
          account(s), or (iv) account on which such Employee has a controlling power or exercises significant
          influence.</small
        >
      </p>

      <p>
        I hereby acknowledge and confirm my agreements with the &ldquo;Employee Personal Account Dealing Policy&rdquo;
        and agree to the following:
      </p>
      <p>
        <ejs-checkbox
          formControlName="willNotDeal"
          label="I will not deal, trade, invest, and/or divest any financial instruments in my name or through the account of a Related Person or any other account under my controlling power unless specifically approved by CIGP HK."
        ></ejs-checkbox>
        @if (form.get('willNotDeal')?.touched && form.get('willNotDeal')?.hasError('required')) {
          <small class="text-danger d-block">This field is required</small>
        }
      </p>
      <p>
        <ejs-checkbox
          formControlName="willSeekApprovalToTrade"
          label="I will seek approval from CIGP HK to engage in any deal, trade, investment, and/or divestment as listed in the &ldquo;Personal Account Dealing Application Policy&rdquo; by completing the &ldquo;Personal Account Dealing Request Form&rdquo;."
        ></ejs-checkbox>
        @if (
          form.get('willSeekApprovalToTrade')?.touched && form.get('willSeekApprovalToTrade')?.hasError('required')
        ) {
          <small class="text-danger d-block">This field is required</small>
        }
      </p>
      <p>
        <ejs-checkbox
          formControlName="willSendTradeConfirmationsAndStatements"
          label="I confirm all electronic/physical copies of trade confirmations and monthly broker statements will be sent to CIGP HK to the address below:"
        ></ejs-checkbox>
      </p>
      @if (
        form.get('willSendTradeConfirmationsAndStatements')?.touched &&
        form.get('willSendTradeConfirmationsAndStatements')?.hasError('required')
      ) {
        <small class="text-danger d-block">This field is required</small>
      }
      <address style="margin: 1rem 0 1rem 2rem; font-size: small">
        Compagnie d'Investissements et de Gestion Priv&eacute;e (Hong Kong) Limited<br />
        26/F Man Yee Building,<br />
        68 Des Voeux Road Central, Central,<br />
        Hong Kong S.A.R.<br />
        <br />
        OR<br />
        <br />
        Attention: Legal and Compliance Department<br />
        Email: <a href="mailto:hrc@cigp.com">HRC&#64;cigp.com</a>
      </address>
      <p>
        <ejs-checkbox
          formControlName="willSeekApprovalToOpenDealingAccount"
          label="I will seek approval from CIGP HK before opening new Personal Dealing Accounts."
        ></ejs-checkbox>
        @if (
          form.get('willSeekApprovalToOpenDealingAccount')?.touched &&
          form.get('willSeekApprovalToOpenDealingAccount')?.hasError('required')
        ) {
          <small class="text-danger d-block">This field is required</small>
        }
      </p>

      <!-- Additional information -->
      <h4>Additional information</h4>
      <div class="mb-3">
        <label class="form-label">Additional information (optional)</label>
        <ejs-textbox multiline="true" rows="4" formControlName="additionalInformation"></ejs-textbox>
      </div>

      @if (alreadySubmitted) {
        <!-- Acknowledgement -->
        <h4>Acknowledgement and Confirmation by the Employee:</h4>
        <p>
          Name: {{ employee }}<br />
          Date: {{ declarationDate | date }}
        </p>
      }
    </form>
    <div class="btn-group">
      @if (alreadySubmitted) {
        <button class="btn btn-primary" disabled>YOU ALREADY SUBMITTED THIS DECLARATION</button>
      } @else {
        <button
          class="btn btn-primary"
          [disabled]="!form.valid || !form.get('additionalInformation')?.valid"
          (click)="submitForm()"
        >
          SUBMIT
        </button>
      }
      <button class="btn btn-secondary" (click)="location.back()">BACK</button>
    </div>
  </div>
</div>

<!-- Syncfusion Acknowledgement Dialog -->
<ejs-dialog #ackDialog [(visible)]="showAckDialog" width="600px" [isModal]="true">
  <ad-personal-account-dealing-declaration-ack-dialog [data]="ackDialogData" (closeDialog)="handleDialogClose($event)">
  </ad-personal-account-dealing-declaration-ack-dialog>
</ejs-dialog>
